var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "900 600 1150 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos_FI_paths",
    "data-name": "Logos FI paths"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1697.71,
    y: 655.29,
    width: 40,
    height: 200,
    rx: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1135,655.88a2,2,0,0,0-1.38-.57H1116l-.28,0h-152a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2H1090l37.8,0a1.93,1.93,0,0,1,1.9,1.53,1.77,1.77,0,0,0,0,.23v36.33a1.93,1.93,0,0,1-1.47,1.88H981.71a2,2,0,0,0-1.77,1.08l-33.66,33.57a2.05,2.05,0,0,0-.57,1.54V819.2a1.94,1.94,0,0,0,.57,1.38l33.8,33.89a2,2,0,0,0,1.62.82h151.85a2,2,0,0,0,1.53-.57l34.06-34.14a2,2,0,0,0,.57-1.38V691.48a2.09,2.09,0,0,0-.57-1.54ZM987.18,815.29a1.94,1.94,0,0,1-1.47-1.88V776.79a1.93,1.93,0,0,1,1.88-1.47l37.9,0h64.44l37.89,0a1.94,1.94,0,0,1,1.89,1.47v36.62a1.93,1.93,0,0,1-1.47,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1657.72,655.29h-148l-.29,0h-3.61a2,2,0,0,0-1.38.57l-34.14,34.06a2.05,2.05,0,0,0-.57,1.54V853.24a2.05,2.05,0,0,0,2,2h35.9a2.05,2.05,0,0,0,2-2V696.79a1.93,1.93,0,0,1,1.88-1.47l37.81,0h108.32a2,2,0,0,0,2-2v-36A2,2,0,0,0,1657.72,655.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1431.71,657.27a2,2,0,0,0-2-2h-36.06a2,2,0,0,0-2,2V803.08a1.62,1.62,0,0,0,0,.22l0,10.11a1.93,1.93,0,0,1-1.47,1.88h-141a1.94,1.94,0,0,1-1.47-1.88V803.3c0-.07,0-.15,0-.22V657.27a2,2,0,0,0-2-2h-36.06a2,2,0,0,0-2,2V803.08h0V819.2a1.94,1.94,0,0,0,.57,1.38l34.06,34.14a2,2,0,0,0,1.53.57h151.68a2,2,0,0,0,1.53-.57l34.06-34.14a2,2,0,0,0,.57-1.38V771.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1999.14,770l-34.06-34.15a2.08,2.08,0,0,0-1.53-.57H1817.27a1.93,1.93,0,0,1-1.56-1.9l-.06-36.15a1.94,1.94,0,0,1,1.94-1.94l24.16,0h140a1.93,1.93,0,0,0,1.93-1.93V657.22a1.94,1.94,0,0,0-1.93-1.93h-170a2,2,0,0,0-1.38.57l-34.14,34.06a2.05,2.05,0,0,0-.57,1.54v47.72a1.94,1.94,0,0,0,.57,1.38l34.06,34.14a2,2,0,0,0,1.53.57h1.07a1.42,1.42,0,0,0,.29,0h145a1.94,1.94,0,0,1,1.51,1.9l.07,36.15a1.94,1.94,0,0,1-2,1.94H1793.64a1.93,1.93,0,0,0-1.93,1.93v36.14a1.92,1.92,0,0,0,1.93,1.93h170a1.94,1.94,0,0,0,1.38-.57l34.14-34.06a2.07,2.07,0,0,0,.57-1.53V771.39A2,2,0,0,0,1999.14,770Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1222,951.73h28.23v7.7h-19.76V972h18.21v7.48h-18.21v14h19.9v7.69H1222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1338,951.73v49.4h-8.26l-26.61-36.27v36.27H1295v-49.4h8.61l26.25,36.21V951.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1384.89,951.73h28.23v7.7h-19.76V972h18.2v7.48h-18.2v14h19.9v7.69h-28.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1466.32,1001.13h-8.4v-49.4h15.46c9.95,0,16.93,5.44,16.93,15,0,7.34-4.58,12.28-11.15,14.12l14.54,20.25h-10l-13.62-19.55h-3.81Zm0-26.67h7.06c4.94,0,8.47-2.83,8.47-7.62s-3.53-7.49-8.47-7.49h-7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1572,967.26a15.33,15.33,0,0,0-14.19-8.4c-9.38,0-16.86,7.83-16.86,17.57s7.41,17.58,16.94,17.58c7.83,0,13.69-5.09,14.82-12.21h-16.1v-7.41h25.13v3.17c0,13.76-9.88,24.42-23.93,24.42a25.58,25.58,0,0,1,.08-51.16c9.59,0,17.71,4.94,21.66,12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1634.27,951.73v49.4h-8.47v-49.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1703.35,951.73l20.11,49.4h-8.89l-5-12.49h-19.9l-4.94,12.49H1676l20.11-49.4Zm-10.94,29.5h14.47l-7.27-18.35Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e3506ad0fc380c5f506e8e59813896a.svg";
export { ForwardRef as ReactComponent };